import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  dismiss() {
    if (this.element.classList.contains('ui-alert--dismissing')) return;

    this.element.addEventListener('animationend', (event) => {
      if (event.target !== this.element) return;
      this.dispatch('dismissed');
      this.element.remove();
    });
    this.element.classList.add('ui-alert--dismissing');
  }
}
